import React from 'react'
import { InfoCircle } from 'src/assets/images'

interface IProps {
  place: string
  description: string
  forId: string
}

export function CustomInfoTooltip({ place, description, forId }: IProps) {
  return (
    <img
      data-for={forId}
      data-place={place}
      data-tip={description}
      data-effect="solid"
      src={InfoCircle}
      alt="info icon"
    />
  )
}
